'use client';

import { Button } from '@/components/common/Button/Button';
import { useAppNavigationDialog } from '../AppNavigationDialog/useAppNavigationDialog';
import { useTranslations } from 'next-intl';
import { makeTopDeepLink } from '@/utils/deeplink';

interface AppDownloadButtonProps {
  className?: string;
}

export function AppDownloadButton({ className }: AppDownloadButtonProps) {
  const { navigate, Dialog } = useAppNavigationDialog({ href: makeTopDeepLink() });
  const t = useTranslations('common');

  return (
    <>
      <Button size="small" colorScheme="primary" onClick={() => navigate()} className={className}>
        {t('globalHeader.action.install')}
      </Button>
      {Dialog}
    </>
  );
}
